<template>
  <div class="main">
    <b-form :class="{'b-layout': true, 'form-geral': true,  'ml-2': true, 'mr-2': true, 'readOnly': readOnly}" @submit.prevent="">
      <p>{{ $t('moagem-prevista') }}</p>
      <div class="box-edit">
        <span>
          <label>{{ $t('moagem-efetiva-ton-dia') }}</label>
          <b-input class="input-pentagro" v-model.lazy="inputLabel.corn.chields.moagem" step="50" min="0" type="number"></b-input>
        </span>
        <span>
          <label>{{ $t('moagem-efetiva-ton-h') }}</label>
          <b-input class="input-pentagro" v-model.lazy="inputLabel.corn.chields.moagemHora" step="50" min="0" type="number"></b-input>
        </span>
      </div>

      <p>{{ $t('qualidade-do-milho') }}</p>
      <div class="box-edit">
        <span>
          <label>{{ $t('fibra') }}</label>
          <b-input class="input-pentagro" v-model="inputLabel.corn.chields.fibra"  @change="updateWaterToCompleteProportion" min="0" max="100" step="0.01" type="number"></b-input>
        </span>

        <span>
          <label>{{ $t('proteina') }}</label>
          <b-input class="input-pentagro" v-model="inputLabel.corn.chields.protein" @change="updateWaterToCompleteProportion" min="0" max="100" step="0.01" type="number"></b-input>
        </span>

        <span>
          <label>{{ $t('oleo') }}</label>
          <b-input class="input-pentagro" v-model="inputLabel.corn.chields.oil" @change="updateWaterToCompleteProportion" min="0" max="100" step="0.01" type="number"></b-input>
        </span>

        <span>
          <label>{{ $t('cinzas') }}</label>
          <b-input class="input-pentagro" v-model="inputLabel.corn.chields.ashes" @change="updateWaterToCompleteProportion" min="0" max="100" step="0.01" type="number"></b-input>
        </span>

        <span v-if="showStraw"> 
          <label>{{ $t('impureza-vegetal-kg-tc') }} </label>
          <b-input class="input-pentagro" v-model="inputLabel.corn.chields.palha" @change="updateWaterToCompleteProportion" min="0" max="100" type="number"></b-input>
        </span>

        <span>
          <label>{{ $t('amido')}}</label>
          <b-input class="input-pentagro" v-model="inputLabel.corn.chields.starchToView" @change="updateWaterToCompleteProportion" min="0" max="100" step="0.01" type="number"></b-input>
        </span>
        
        <span>
          <label>{{ $t('acucares-corn') }}</label>
          <b-input class="input-pentagro" v-model="inputLabel.corn.chields.sugarToView" @change="updateRatioSugar" min="0" max="100" step="0.01" type="number"></b-input>
        </span>
  
        <span>
          <label>{{ $t('agua-corn') }}</label> 
          <label>{{ inputLabel.corn.chields.water }}</label>
        </span>
      </div>

     

    </b-form>
    <b-form class="ml-3 mr-3" v-if="!readOnly">
      <!-- CORRENTE -->
      <div>
        <div class="pt-2">
            <label for="select-current">{{ $t('escolha-a-corrente-do-milho') }}</label>
        </div>

        <div>
          <select 
            id="select-current" 
            class="form-control" 
            @change="changeCurrent()" 
            v-model="inputLabel.corn.current"> 
              <option value="" selected>{{ $t('escolha-uma-corrente-0') }}</option>
              <option v-for="(current, index) in currentsCorn"
                :key="`node-current-${index}`" :value="current">
                  {{current}}
              </option>
          </select>
        </div>
        <!--/CORRENTE -->
      </div>

      <div>
        <div class="pt-2 mb-0">
            <label for="select-current">{{ $t('proporcao-dos-acucares') }}</label>
            <b-icon class="question-icon" font-scale="0.9" icon="question-circle-fill" v-b-popover.hover="{ variant: 'secondary',  content:this.$t('explicacao-acucares-milho'), }"></b-icon>
          </div>
          <div>
            <b-input class="input-pentagro" @change="checkProportionOfSugars" v-model="proportionOfSugars" maxlength="15" type="text"></b-input>
            <label v-if="errorProportion" class="error-message">{{ $t('proporcao-invalida-ex-4-2-1-1-0') }}</label>
        </div>
      </div>

      <div v-if="showStraw">
        <div class="pt-2 mb-0">
            <label for="select-current">{{ $t('configure-a-corrente-da-palha') }}</label>
        </div>
        <div>
          <select 
            id="select-currentStraw" 
            class="form-control" 
            @change="changeCurrentStraw()" 
            v-model="inputLabel.corn.currentStraw"> 
              <option value="" selected>{{ $t('escolha-uma-corrente-para-palha') }}</option>
              <option v-for="(current, index) in currents"
                :key="`node-current-${index}`" :value="current">
                  {{current}}
              </option>
          </select>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import { urlMainAPI, defaultSuccess } from "@/global";
import { SingletonEnginnering } from "../_service/singletonEngineering"
import { NumberFormat ,ParseToNumber } from "../../utils/tools"
import { WaitMixin } from "../../../mixins/waitMixin"
import { SimpleNumberFormat } from '../../../../global';

  export default {
    props: {
      node: {
        type: Object,
        default: null
      },
      importONLS: {
        type: Number
      },
      readOnly:{
      type: Boolean,
      default: false,
    }
    },

    mixins: [ WaitMixin ],

    data() {
      return {
        sumAllElements: 0,
        firstLoad: true,
        showStraw: this.node.showStraw,
        straw: {},
        currentsCorn: SingletonEnginnering.currents.filter(cr => String(cr).match(/\b1_.+/g)),
        currents: SingletonEnginnering.currents,
        operations: [
            ...SingletonEnginnering.operations.filter(op => String(op).match(/\bTorreResfriamento/g)), 
            ...SingletonEnginnering.operations.filter(op => String(op).match(/\bEvaporativeCondenser/g))
        ],
        inputLabel: {
          corn: { 
            caption: this.$t('qualidade-do-milho'),
            attrs: [],
            current: '',
            currentStraw: '',
            chields: {
              moagem: 0,
              moagemHora: 0,
              temperatura: 0,
              fibra: 0, 
              oil: 0,
              protein: 0,
              ar: 0,
              ashes:  0,
              starch: 0,
              sucrose:  0,
              glucose:  0,
              fructose:  0,
              maltose:  0,
              maltriose:  0,
              palha: 0,
              water: 0,
              frassaoMassicaCaldo: 0,
              starchToView: 0,
              sugarToView: 0
            }
          },
          climate: { 
            caption: this.$t('clima'),
            attrs: [],
            operation: '',
            chields: {
              tempBulboSeco: 0,
              umidadeRelativaAr: 0
            }
          },
        },
        errorProportion: false,
        proportionOfSugars: "",
        sugars: 0,
      }
    },

    watch:{
      proportionOfSugars(value){
        let split = value.split(":")
        if(split.length != 5 || (!split[4] && parseInt(split[4]) != 0)){
          this.errorProportion = true;
          return
        }
        this.errorProportion = false;
        this.updateNode();
      },

      "inputLabel.corn.chields.moagem"(value){
        if(this.firstLoad) return
        this.inputLabel.corn.attrs.forEach(a => {
          if(a.key == "W" && a.observation)
            a.value = NumberFormat(value / 24)
            this.inputLabel.corn.chields.moagemHora = value / 24
        })
        this.updateNode();
      },

      "inputLabel.corn.chields.moagemHora"(value){
        if(this.firstLoad) return
        this.inputLabel.corn.attrs.forEach(a => {
          if(a.key == "W" && a.observation)
            a.value = NumberFormat(value)
            this.inputLabel.corn.chields.moagem = value * 24
        })
        this.updateNode();
      },

      "inputLabel.corn.chields.temperatura"(value){
        if(this.firstLoad) return
        let temp = 0;
        this.inputLabel.corn.attrs.forEach(a => {
          if(a.key == "T"){
            temp = NumberFormat(value)
            a.value = temp
          }
        })

        this.inputLabel.climate.attrs.forEach(a => {
          if(a.key == "TBS")
            a.value = temp
        })
        this.updateNode();
      },

      "inputLabel.corn.chields.fibra"(value){
        if(this.firstLoad) return
        this.inputLabel.corn.attrs.forEach(a => {
          if(a.key == "fracaoMassica" && a.propName == "FibraMilho"){
            a.value = value
          }
        })
        this.updateNode();
      },

      "inputLabel.corn.chields.oil"(value){
        if(this.firstLoad) return
        this.inputLabel.corn.attrs.forEach(a => {
          if(a.key == "fracaoMassica" && a.propName == "Oleo")
            a.value = NumberFormat(value)
        })
        this.updateNode();
      },

      "inputLabel.corn.chields.protein"(value){
        if(this.firstLoad) return
        this.inputLabel.corn.attrs.forEach(a => {
          if(a.key == "fracaoMassica" && a.propName == "Proteina")
            a.value = NumberFormat(value)
        })
        this.updateNode();
      },

      "inputLabel.corn.chields.ashes"(value){
        if(this.firstLoad) return
        this.inputLabel.corn.attrs.forEach(a => {
          if(a.key == "fracaoMassica" && a.propName == "Cinzas")
            a.value = NumberFormat(value)
        })
        this.updateNode();
      },

      "inputLabel.corn.chields.starchToView"(value){
        if(this.firstLoad) return
        this.inputLabel.corn.attrs.forEach(a => {
          if(a.key == "O2") 
          {
            a.value = NumberFormat(value / this.inputLabel.corn.chields.frassaoMassicaCaldo);
          }
        })
        this.updateNode();
      },

      "inputLabel.corn.chields.palha"(value){
        if(this.firstLoad) return
        this.straw.value = NumberFormat(value);
        this.updateNode();
      },

      "inputLabel.climate.chields.umidadeRelativaAr"(value){
        if(this.firstLoad) return
        this.inputLabel.climate.attrs.forEach(a => {
          if(a.key == "Umidade") {
            a.value = NumberFormat(value)
          }
        })

        this.updateNode();
      },

      showStraw(){
        this.updateNode(); 
      },

      importONLS(){
        this.waitOn()
        const listTags = [  
                            'input_online_cornMoagem',
                            'input_online_cornFibra',
                            'input_online_cornProteina',
                            'input_online_cornOleo',
                            'input_online_cornCinzas',
                            'input_online_cornAmido',
                            'input_online_cornSugarS2',
                            'input_online_cornAgua'
        ]
        defaultSuccess(this.$t('importando-dados-do-processo'))
        console.log('Importar dados do Milho :>> ', listTags);
        axios.post(`${urlMainAPI}/getcornquality`, listTags).then(resp => {
          if(resp.status == 200)
            defaultSuccess(this.$t('dados-importados-com-sucesso'))

          let result = resp.data
        
          this.inputLabel.corn.chields.sugarToView =  result[listTags[6]] ? parseFloat(result[listTags[6]]) : 0
          
          this.inputLabel.corn.chields.fibra = result[listTags[1]] ? parseFloat(result[listTags[1]]) : ( 100 - 
          (
            this.inputLabel.corn.chields.sugarToView + //açucar recebido ou calculado (zerado)
            parseFloat(result[listTags[2]]) + //proteina
            parseFloat(result[listTags[3]]) + //oleo
            parseFloat(result[listTags[4]]) + //cinzas
            parseFloat(result[listTags[5]]) + //amido
            parseFloat(result[listTags[7]]) //agua
          ))
        
          let sumToFindFMCaldo = this.inputLabel.corn.chields.fibra + //fibra recebida ou calculada (completada acima)
          parseFloat(result[listTags[2]]) + //proteina
          parseFloat(result[listTags[3]]) + //oleo
          parseFloat(result[listTags[4]]) //cinzas

          this.inputLabel.corn.chields.frassaoMassicaCaldo = ( 100 - sumToFindFMCaldo )

          this.inputLabel.corn.chields.moagem = parseFloat(result[listTags[0]]) * 24
          this.inputLabel.corn.chields.moagemHora = parseFloat(result[listTags[0]])
          this.inputLabel.corn.chields.protein = parseFloat(result[listTags[2]])
          this.inputLabel.corn.chields.oil =  parseFloat(result[listTags[3]])
          this.inputLabel.corn.chields.ashes = parseFloat(result[listTags[4]])
          this.inputLabel.corn.chields.starchToView = parseFloat(result[listTags[5]])
          this.inputLabel.corn.chields.water =  parseFloat(result[listTags[7]])

          this.waitOff()
            
          }).catch(err => {console.log(err);  this.waitOff()})
          setTimeout(() => {
            this.updateRatioSugar();
          }, 1000);
        },
    },

    methods: {
      loadNode(){
        this.firstLoad = true;
        let attrs = new Array();
        this.inputLabel.corn.attrs = [];
        this.sugars = 0;
        let water = {};
        
        this.proportionOfSugars = this.node.proportionOfSugars

        this.node.data.forEach((a) => 
        {
          if(a.propName == "CaldoMilho")
          {
            if(a.key == "fracaoMassica") this.inputLabel.corn.chields.frassaoMassicaCaldo = (ParseToNumber(NumberFormat(a.value))); //fracao massica total
          }
        });
        
        this.node.data.forEach((a) => {
          if(a.key == "W" && a.observation) {
            this.inputLabel.corn.chields.moagem = ParseToNumber(NumberFormat(a.value)) * 24
            this.inputLabel.corn.chields.moagemhora = ParseToNumber(NumberFormat(a.value))
          }

          if(a.key == "fracaoMassica" && a.propName == "FibraMilho") this.inputLabel.corn.chields.fibra = ParseToNumber(NumberFormat(a.value)).toFixed(2)
          if(a.key == "fracaoMassica" && a.propName == "Proteina") this.inputLabel.corn.chields.protein = ParseToNumber(NumberFormat(a.value)).toFixed(2)
          if(a.key == "fracaoMassica" && a.propName == "Oleo") this.inputLabel.corn.chields.oil = ParseToNumber(NumberFormat(a.value)).toFixed(2)
          if(a.key == "fracaoMassica" && a.propName == "Cinzas") this.inputLabel.corn.chields.ashes = ParseToNumber(NumberFormat(a.value)).toFixed(2)
          
          if(a.propName == "CaldoMilho")
          {
            if(a.key == "H2") 
            {
              water = a.clone() // Agua
            } 

            if(a.key == "O2") 
            {
              this.inputLabel.corn.chields.starch = (ParseToNumber(NumberFormat(a.value)) * 100).toFixed(2) // Amido
              this.inputLabel.corn.chields.starchToView = (parseFloat(this.inputLabel.corn.chields.frassaoMassicaCaldo) * (this.inputLabel.corn.chields.starch / 100)).toFixed(2) // Amido para visualização
            } 
            
            if(a.key == "N2") this.inputLabel.corn.chields.fructose = ParseToNumber(NumberFormat(a.value)) // Frutose
            
            if(a.key == "S2") this.inputLabel.corn.chields.sucrose = ParseToNumber(NumberFormat(a.value)) // Sacarose
            
            if(a.key == "C") this.inputLabel.corn.chields.glucose = ParseToNumber(NumberFormat(a.value)) // Glicose
            
            if(a.key == "Cel") this.inputLabel.corn.chields.maltriose = ParseToNumber(NumberFormat(a.value)) // Maltotriose

            if(a.key == "Cinzas") this.inputLabel.corn.chields.maltose = ParseToNumber(NumberFormat(a.value)) // Maltose
            
            if(a.key == "N2" || a.key == "S2" || a.key == "C" || a.key == "Cel" || a.key == "Cinzas") 
            {
              this.sugars += ParseToNumber(NumberFormat(a.value))
            }
          }
          
          if(a.key == "W" && !a.observation)
          {
            this.inputLabel.corn.chields.palha = ParseToNumber(a.value)
            this.inputLabel.corn.currentStraw = a.index
            this.straw = a
          }             
          
          else if(a.key != "TBS" && a.key != "Umidade"){
            attrs.push(a)
          }
          
          if(!this.inputLabel.corn.current && a.observation)
          this.inputLabel.corn.current = attrs[0].index
        });
      
        this.sugars = this.sugars * 100;
        
        this.inputLabel.corn.chields.sugarToView = (parseFloat(this.inputLabel.corn.chields.frassaoMassicaCaldo) * (this.sugars / 100)).toFixed(2) // acucar para visualização
      
        this.sumToFindWater();

        water.value = SimpleNumberFormat(this.inputLabel.corn.chields.water) / parseFloat(this.inputLabel.corn.chields.frassaoMassicaCaldo)

        this.sugars = this.sugars.toFixed(2);

        this.inputLabel.corn.attrs = attrs;

        this.firstLoad = false;

        this.updateSugarPropNode();
      },

      updateNode(){
        if(this.firstLoad) return;

        this.node.attrs = [...this.inputLabel.corn.attrs, ...this.inputLabel.climate.attrs]
        this.node.showStraw = this.showStraw;
        this.node.proportionOfSugars = this.proportionOfSugars;
        if(this.showStraw && this.straw){
          this.node.attrs = [...this.node.attrs, this.straw ];
        }
      },

      changeCurrentStraw(){
        let props = SingletonEnginnering.getCurrentPropertiesAttributes(this.inputLabel.corn.currentStraw, {name: "Atributos", index: 0});
        props.forEach(p => {
          if(p.key == "W"){
            this.straw = p
            this.inputLabel.corn.chields.palha = ParseToNumber(p.value)
          }
        })
      },

      changeCurrent(){
        let props = SingletonEnginnering.getCurrentProperties(this.inputLabel.corn.current);
        this.inputLabel.corn.attrs = new Array();

        props.forEach(prop => {
          if(prop.name == "Atributos"){
            let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(this.inputLabel.corn.current, prop)

            attrs.forEach(attr => {
              if(attr.key == "W"){
                this.inputLabel.corn.chields.moagem = ParseToNumber(NumberFormat(attr.value)) * 24
                this.inputLabel.corn.chields.moagemHora = ParseToNumber(NumberFormat(attr.value))
                attr.observation = "cana"
                this.inputLabel.corn.attrs.push(attr)
              }

              if(attr.key == "POL"){
                this.inputLabel.corn.chields.protein = ParseToNumber(attr.value)
                this.inputLabel.corn.attrs.push(attr)
              }

              if(attr.key == "AR"){
                this.inputLabel.corn.chields.ar = ParseToNumber(attr.value)
                this.inputLabel.corn.attrs.push(attr)
              }

              if(attr.key == "T"){
                this.inputLabel.corn.chields.temperatura = ParseToNumber(attr.value)
                this.inputLabel.corn.attrs.push(attr)
              }
            })
          }

          if(prop.name == "CaldoMilho"){
            let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(this.inputLabel.corn.current, prop)
            this.sugars = 0
            attrs.forEach(attr => {
              if(attr.key == "S2"){
                this.inputLabel.corn.chields.sucrose = ParseToNumber(attr.value)
                this.inputLabel.corn.attrs.push(attr)
              }
              if(attr.key == "N2"){
                this.inputLabel.corn.chields.fructose = ParseToNumber(attr.value)
                this.inputLabel.corn.attrs.push(attr)
              }
              if(attr.key == "H2"){
                this.inputLabel.corn.attrs.push(attr)
              }
              if(attr.key == "Cinzas"){
                this.inputLabel.corn.chields.maltose = ParseToNumber(attr.value)
                this.inputLabel.corn.attrs.push(attr)
              }
              if(attr.key == "Cel"){
                this.inputLabel.corn.chields.maltriose = ParseToNumber(attr.value)
                this.inputLabel.corn.attrs.push(attr)
              }
              if(attr.key == "C"){
                this.inputLabel.corn.chields.glucose = ParseToNumber(attr.value)
                this.inputLabel.corn.attrs.push(attr)
              }
              if(attr.key == "O2"){
                this.inputLabel.corn.chields.starch = (ParseToNumber(attr.value) * 100)
                this.inputLabel.corn.attrs.push(attr)
              }

              if(attr.key == "N2" || attr.key == "S2" || attr.key == "C" || attr.key == "Cel" || attr.key == "Cinzas") {
                this.sugars += ParseToNumber(NumberFormat(attr.value))
              }

              if(attr.key == "fracaoMassica") { 
                this.inputLabel.corn.chields.frassaoMassicaCaldo = ParseToNumber(NumberFormat(attr.value))
                this.inputLabel.corn.attrs.push(attr)
            }
            })

            this.sugars = (this.sugars * 100).toFixed(2);
          }
          
          this.inputLabel.corn.chields.starchToView = (this.inputLabel.corn.chields.frassaoMassicaCaldo * (this.inputLabel.corn.chields.starch / 100)).toFixed(2) 
          this.inputLabel.corn.chields.sugarToView = (this.inputLabel.corn.chields.frassaoMassicaCaldo * (this.sugars / 100)).toFixed(2) 

          this.sumToFindWater();

          if(prop.name == "FibraMilho"){
            let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(this.inputLabel.corn.current, prop)
            attrs.forEach(attr => {
              if(attr.key == "fracaoMassica"){
                this.inputLabel.corn.chields.fibra = ParseToNumber(attr.value)
                this.inputLabel.corn.attrs.push(attr)
              }
            })
          }

          if(prop.name == "Proteina"){
            let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(this.inputLabel.corn.current, prop)
            attrs.forEach(attr => {
              if(attr.key == "fracaoMassica"){
                this.inputLabel.corn.chields.protein = ParseToNumber(attr.value)
                this.inputLabel.corn.attrs.push(attr)
              }
            })
          }

          if(prop.name == "Oleo"){
            let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(this.inputLabel.corn.current, prop)
            attrs.forEach(attr => {
              if(attr.key == "fracaoMassica"){
                this.inputLabel.corn.chields.oil = ParseToNumber(attr.value)
                this.inputLabel.corn.attrs.push(attr)
              }
            })
          }

          if(prop.name == "Cinzas"){
            let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(this.inputLabel.corn.current, prop)
            attrs.forEach(attr => {
              if(attr.key == "fracaoMassica"){
                this.inputLabel.corn.chields.ashes = ParseToNumber(attr.value)
                this.inputLabel.corn.attrs.push(attr)
              }
            })
          }
        })

        this.updateNode()
      },

      async loadTowers(){
        let attrs = []
        this.operations.forEach(tower => {
          attrs = [...SingletonEnginnering.getOperationsProperties(tower), ...attrs];
        })
        this.inputLabel.climate.attrs = new Array()

        attrs.forEach(attr => {
          if(attr.caption == "TBS"){
            this.inputLabel.climate.attrs.push(attr)
          }

          if(attr.caption == "Umidade"){
            this.inputLabel.climate.chields.umidadeRelativaAr = ParseToNumber(attr.value)
            this.inputLabel.climate.attrs.push(attr)
          }
        })
      },

      updateWaterToCompleteProportion() {
        let water = {}
        let sugarView = 0;
        
        this.inputLabel.corn.chields.frassaoMassicaCaldo = 100 - (
          parseFloat(this.inputLabel.corn.chields.fibra) + 
          parseFloat(this.inputLabel.corn.chields.protein) + 
          parseFloat(this.inputLabel.corn.chields.oil) + 
          parseFloat(this.inputLabel.corn.chields.ashes) )

          this.inputLabel.corn.attrs.forEach(a => 
          {
            if(a.key == "O2" && a.propName == "CaldoMilho")
            {
              this.inputLabel.corn.chields.starchToView = (ParseToNumber(a.value) * parseFloat(this.inputLabel.corn.chields.frassaoMassicaCaldo)).toFixed(2);
            }

            if(a.key == "N2" || a.key == "S2" || a.key == "C" || a.key == "Cel" || a.key == "Cinzas") 
            {
              sugarView += ParseToNumber(a.value)
            }
          })
            
          this.inputLabel.corn.chields.sugarToView = (this.inputLabel.corn.chields.frassaoMassicaCaldo * (sugarView)).toFixed(2) 

          this.inputLabel.corn.attrs.forEach(a => {
          if(a.key == "H2" && a.propName == "CaldoMilho"){
            this.sumToFindWater();

            a.value = NumberFormat(SimpleNumberFormat(this.inputLabel.corn.chields.water) / parseFloat(this.inputLabel.corn.chields.frassaoMassicaCaldo));

            water = a;
          }
          water.value = SimpleNumberFormat(this.inputLabel.corn.chields.water) / parseFloat(this.inputLabel.corn.chields.frassaoMassicaCaldo)
          
          
          if(a.key == "fracaoMassica" && a.propName == "CaldoMilho"){
              a.value = NumberFormat(this.inputLabel.corn.chields.frassaoMassicaCaldo);
          }
          this.updateNode()
        })
      },

      updateSugarPropNode() {
        let split = this.proportionOfSugars.split(":")

        if(split.length != 5) {
          this.errorProportion = true
          return
        }
        else
          this.errorProportion = false

        let totalProportion = split.reduce((total,num) => total + parseInt(num), 0)
       
        this.inputLabel.corn.attrs.forEach(a => {
          let value = ParseToNumber(a.value) * 100

          if(a.key == "fracaoMassica" && a.propName == "CaldoMilho"){
              a.value = NumberFormat(this.inputLabel.corn.chields.frassaoMassicaCaldo);
          }

          if(a.key == "S2" && a.propName == "CaldoMilho"){
            value = (parseInt(split[0]) / totalProportion * this.inputLabel.corn.chields.sugarToView);
            a.value = NumberFormat(value / this.inputLabel.corn.chields.frassaoMassicaCaldo);
          }
          
          if(a.key == "C" && a.propName == "CaldoMilho"){
            value = (parseInt(split[1]) / totalProportion * this.inputLabel.corn.chields.sugarToView);
            a.value = NumberFormat(value / this.inputLabel.corn.chields.frassaoMassicaCaldo);
          }

          if(a.key == "N2" && a.propName == "CaldoMilho"){
            value = (parseInt(split[2]) / totalProportion * this.inputLabel.corn.chields.sugarToView);
            a.value = NumberFormat(value / this.inputLabel.corn.chields.frassaoMassicaCaldo);
          }

          if(a.key == "Cinzas" && a.propName == "CaldoMilho"){
            value = (parseInt(split[3]) / totalProportion * this.inputLabel.corn.chields.sugarToView);
            a.value = NumberFormat(value / this.inputLabel.corn.chields.frassaoMassicaCaldo);
          }

          if(a.key == "Cel" && a.propName == "CaldoMilho"){''
            value = (parseInt(split[4]) / totalProportion * this.inputLabel.corn.chields.sugarToView);
            a.value = NumberFormat(value / this.inputLabel.corn.chields.frassaoMassicaCaldo);
          }
        })
      },

      updateRatioSugar(){
        this.inputLabel.corn.chields.frassaoMassicaCaldo = 100 - (
        parseFloat(this.inputLabel.corn.chields.fibra) + 
        parseFloat(this.inputLabel.corn.chields.protein) + 
        parseFloat(this.inputLabel.corn.chields.oil) + 
        parseFloat(this.inputLabel.corn.chields.ashes) )

        this.updateSugarPropNode();
        this.updateWaterToCompleteProportion();
        this.updateNode();
      },

      checkProportionOfSugars(){
        this.proportionOfSugars = this.proportionOfSugars.replace(/[^0-9:]/g, "")
        this.updateRatioSugar();
      },

      sumToFindWater() {
        this.sumAllElements = parseFloat(this.inputLabel.corn.chields.fibra) + parseFloat(this.inputLabel.corn.chields.protein) + parseFloat(this.inputLabel.corn.chields.oil) + parseFloat(this.inputLabel.corn.chields.ashes) + parseFloat(this.inputLabel.corn.chields.starchToView) + parseFloat(this.inputLabel.corn.chields.sugarToView)
        this.inputLabel.corn.chields.water =  NumberFormat(100 - this.sumAllElements); 
      }
    },
    
    mounted(){ 
      this.loadNode();
    },

    destroyed() {
      this.waitOff();
    },
  }
</script>

<style scoped>

.main{
  display: flex;
  font-size: 0.9rem;
}

.form-geral{
  width: 345px;
}

form{
  color: #0009;
}

.form-geral>p{
  display: inline;
  position: relative;
  padding: 4px;
  top: 9px;
  font-weight: bold;
  margin: 5px 0px 0px 3px;
  background-color: white;
}

.box-edit{
  padding: 8px;
  box-shadow: 0px 0px 3px #0008;
  border-radius: 3px;
}

.box-edit>span{
  display: flex;
  justify-content: space-between;
}

.box-edit>span>input{
  width: 115px;
  height: 20px;
  text-align: right;
  border: #ff5f00 solid 1px;
}

.box-edit>span>label{
  margin-left: 5px;
  margin-bottom: 2px;
}


.box-edit>span>input:focus{
  box-shadow: 0px 0px 5px #ff5f00;
}

.form-geral.readOnly>p{
  background-color: rgb(250, 250, 250)
}

.error-message{
  color: #e00;
  font-size: 0.8rem;

}

.question-icon{
  color: #ff5f00;
  cursor: help;
  margin: 0px 10px 5px 4px;
}

</style>